<template>
  <div class="course-overview">
    <div v-if="!!course.owned_by && !!course.is_online" class="row mb-2">
      <div class="col-4 col-attribute">Trainer Company:</div>
      <div class="col-8 col-value">{{ course.owner_name }}</div>
    </div>
    <div v-if="!!course.category" class="row mb-2">
      <div class="col-4 col-attribute">Category:</div>
      <div class="col-8 col-value">{{ course.category }}</div>
    </div>
    <div v-if="!!course.topic" class="row mb-2">
      <div class="col-4 col-attribute">Topic:</div>
      <div class="col-8 col-value">{{ course.topic }}</div>
    </div>
    <div v-if="!!course['length']" class="row mb-2">
      <div class="col-4 col-attribute">Length:</div>
      <div class="col-8 col-value">{{ course["length"] }}</div>
    </div>
    <div v-if="!!course.hours" class="row mb-2">
      <div class="col-4 col-attribute">Hours:</div>
      <div class="col-8 col-value" v-html="course.hours"></div>
    </div>
    <div v-if="!!course.show_pricing" class="row mb-2">
      <div class="col-4 col-attribute">Pricing:</div>
      <div class="col-8 col-value" v-html="course.pricing"></div>
    </div>
    <div v-if="!!course.series_discount" class="row mb-2">
      <div class="col-4 col-attribute">Series Discount:</div>
      <div class="col-8 col-value">
        {{ course.series_discount }} when purchased as part of the "{{
          course.series_name
        }}" series
      </div>
    </div>
    <div
      v-if="!!course.prerequisites && course.prerequisites.length > 0"
      class="row mb-2"
    >
      <div class="col-4 col-attribute">Prerequisite Courses:</div>
      <div class="col-8 col-value" v-html="prerequisites"></div>
    </div>
    <div v-if="!!enrollment" class="row mb-2">
      <div class="col-4 col-attribute">Course Expiration:</div>
      <div class="col-8 col-value">{{ enrollment.expiration }}</div>
    </div>
    <div
      v-else-if="!!course.is_online && !!course.expiry_days"
      class="row mb-2"
    >
      <div class="col-4 col-attribute">Course Expiration:</div>
      <div class="col-8 col-value">{{ course.expiry_days }}</div>
    </div>
    <div v-if="!!course.show_survey && !!course.survey_url" class="row mb-2">
      <div class="col-4 col-attribute">Survey:</div>
      <div class="col-8 col-value">
        <a :href="course.survey_url" class="text-primary" target="_blank">Take Survey</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    course: { type: Object, required: true },
    enrollment: { type: Object },
  },
  computed: {
    prerequisites() {
      let items = [];
      this.course.prerequisites.each((p) => {
        var url = this.route("catalog.course", { course: p.id });
        var link = `<a href="${url}">${p.name}</a>`;
        items.push(link);
      });
      return items.join("<br />");
    },
  },
};
</script>
